var InputDefaultProps = {
  icons: [],
  valid: false,
  disabled: false,
  autoFocus: false,
  required: false,
  as: 'input',
  type: 'text',
  height: 56,
  active: false,
  readOnly: false,
  tabIndex: 0
};

export { InputDefaultProps };
